import { Integration } from 'signup-constants/Integration';
export const IntegrationName = {
  [Integration.Wordpress]: 'Wordpress',
  [Integration.Wpforms]: 'WPForms',
  [Integration.Shopify]: 'Shopify',
  [Integration.Typeform]: 'Typeform',
  [Integration.ShopifyEmbedded]: 'Shopify Embedded',
  [Integration.GoogleWorkspaceApp]: 'Google Workspace App',
  [Integration.ClaudeConnector]: 'Claude',
  [Integration.ChatGptConnector]: 'ChatGPT'
};